import { createContext } from 'react';

/** Falha ao criar a primeira locação com o contrato do locador: a etapa oferece seguir sem ele. */
export interface FalhaContratoOnboarding {
    /** Motivo vindo do servidor, quando não parece ser do contrato e é legível. */
    motivo?: string;
    /** Tenta de novo, agora sem o modelo de contrato. */
    criarSemContrato: () => Promise<void>;
}

export interface OnboardingContextValue {
    ativo: boolean;
    aoCriarLocacao?: (idLocacao: string) => void;
    /** Grava o progresso assim que a locação existe, antes da troca de etapa. */
    registrarLocacaoCriada?: (idLocacao: string) => void;
    aoFalharContrato?: (falha: FalhaContratoOnboarding) => void;
    idModeloContrato?: string;
    /** Pelo Status do onboarding, não há veículo livre para a locação. */
    semVeiculoLivre?: boolean;
}

export const OnboardingContext = createContext<OnboardingContextValue>({ ativo: false });
